import React from 'react';

import { CarsStockDesktopProps } from './types';
import Title from './components/Title';
import Tabs from './components/Tabs';
import SelectedFilters from './components/SelectedFilters';
import CarsListHeader from './components/CarsListHeader';
import CarsList from './components/CarsList';
import CompareButton from './components/CompareButton';
import Pagination from './components/Pagination';

function CarsStockDesktop({ carsType }: CarsStockDesktopProps) {
  return (
    <React.Fragment>
      <Title />
      <Tabs carsType={carsType} />
      <SelectedFilters />
      <CarsListHeader carsType={carsType} />
      <CarsList carsType={carsType} />
      <CompareButton />
      <Pagination />
    </React.Fragment>
  );
}

export default CarsStockDesktop;
